import React from 'react';
import { MemoryRouter, BrowserRouter, Route, Switch } from 'react-router-dom';
import ROUTES from 'constants/ROUTES';
import { createGlobalStyle } from 'styled-components';

import {
  Root as RootPage,
  Game as GamePage,
  Test as TestPage,
  NotFound as NotFoundPage,
} from '../pages';
import { Nav } from '.';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 18px;
    background-color: rgba(12,13,22);
    overflow-y: auto;
    letter-spacing: -0.4px;
  }
`;

export default function App() {
  const Router = process.env.NODE_ENV === 'development' ? BrowserRouter : MemoryRouter;

  return (
    <>
      <GlobalStyle />
      <Nav />
      <Router>
        <Switch>
          <Route exact path={ROUTES.ROOT}>
            <RootPage />
          </Route>
          <Route path={ROUTES.GAME.ROOT}>
            <GamePage />
          </Route>
          <Route path={ROUTES.TEST.ROOT}>
            <TestPage />
          </Route>
          <Route>
            <NotFoundPage />
          </Route>
        </Switch>
      </Router>
    </>
  );
}
